import React, {memo} from 'react'
import {Row} from "react-bootstrap";
import KeywordToolComponent from "../Components/tools/KeywordListComponent";
import KeywordToolViewComponent from "../Components/tools/KeywordToolViewComponent";

function KeywordToolPage(props) {
    return (
        <div className="container">
            <br/>
            <br/>
            <br/>
            <Row>
                <KeywordToolComponent {...props}/>
            </Row>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <Row>
                <KeywordToolViewComponent {...props}/>
            </Row>

        </div>
    )
}

export default memo(KeywordToolPage);